import ComparisonViewDeepDiveNew from './comparisonViewDeepDiveNew'
export default ComparisonViewDeepDiveNew
